import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,430.644706 430.644706,0 960,0 Z M960,112.941176 C492.875294,112.941176 112.941176,492.875294 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 Z M969.118383,733.000074 C1059.70534,732.940603 1124.52027,768.788696 1163.68471,839.072008 L1163.68471,839.072008 L1163.74412,839.072008 L1065.80377,890.215732 C1055.28051,868.431509 1042.48498,853.146691 1027.29742,844.409034 C1011.99013,835.671377 997.879305,831.302999 984.844297,831.302999 C919.550425,831.302999 886.843621,874.511917 886.843621,960.989224 C886.843621,1000.30823 895.154912,1031.72667 911.657759,1055.30582 C928.160606,1078.94535 952.556119,1090.73492 984.844297,1090.73492 C1027.41716,1090.73492 1057.49247,1069.78869 1074.89199,1027.83676 L1074.89199,1027.83676 L1165,1073.6786 C1145.86656,1109.52579 1119.31851,1137.71301 1085.35583,1158.17987 C1051.39405,1178.76747 1013.96353,1189 973.004848,1189 C907.711876,1189 855.093804,1168.88906 815.032695,1128.67259 C775.031004,1088.57596 755,1032.6755 755,961.039684 C755,891.140228 775.210158,835.654256 815.75021,794.659262 C856.169626,753.545327 907.352669,733.000074 969.118383,733.000074 Z",
  fillRule: "evenodd",
  stroke: "#979797",
  strokeWidth: "1"
});

var IconFilesCopyrightSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFilesCopyrightSolid, _Component);

  var _super = _createSuper(IconFilesCopyrightSolid);

  function IconFilesCopyrightSolid() {
    _classCallCheck(this, IconFilesCopyrightSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilesCopyrightSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilesCopyright",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilesCopyrightSolid.displayName = "IconFilesCopyrightSolid";
  return IconFilesCopyrightSolid;
}(Component);

IconFilesCopyrightSolid.glyphName = 'files-copyright';
IconFilesCopyrightSolid.variant = 'Solid';
IconFilesCopyrightSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilesCopyrightSolid;
export { IconFilesCopyrightSolid };